/* eslint no-extend-native: ["error", { "exceptions": ["String"] }] */
/* eslint func-names: ["error", "never"] */
export default {
  extend: () => {
    if (typeof String.prototype.trim === 'undefined') {
      String.prototype.trim = function () {
        return String(this).replace(/^\s+|\s+$/g, '');
      };
    }

    if (typeof String.prototype.capitalize === 'undefined') {
      String.prototype.capitalize = function () {
        return String(this).charAt(0).toUpperCase() + String(this).slice(1);
      };
    }
  },
};
